// Utility to check YBT parameters in Vietnamese flowsheet
// Run this from browser console: checkYBTParameters()

export const checkYBTParameters = () => {
  console.log('🔍 Checking YBT Parameters in Vietnamese Flowsheet...');
  
  // Expected YBT parameters that should appear in Vietnamese flowsheet
  const expectedYBTParams = [
    'biometrics_balance_ybt_composite_deviation',
    'biometrics_balance_ybt_anterior_deviation', 
    'biometrics_balance_ybt_posteromedial_deviation',
    'biometrics_balance_ybt_posterolateral_deviation',
    'biometrics_balance_ybt_performance_ratio',
    'biometrics_balance_ybt_right_composite_reach',
    'biometrics_balance_ybt_left_composite_reach'
  ];

  // Check Vietnamese translations
  console.log('\n📋 Vietnamese Translations Check:');
  expectedYBTParams.forEach(param => {
    try {
      // This would need to import the translation function
      console.log(`✓ ${param} - Translation check needed`);
    } catch (error) {
      console.log(`✗ ${param} - Error: ${error.message}`);
    }
  });

  // Check if parameters are in current flowsheet data
  console.log('\n📊 Flowsheet Data Check:');
  console.log('Look for these parameters in the current flowsheet:');
  expectedYBTParams.forEach(param => {
    console.log(`  - ${param}`);
  });

  // Instructions for manual verification
  console.log('\n🔍 Manual Verification Steps:');
  console.log('1. Go to Vietnamese flowsheet');
  console.log('2. Navigate to Biometrics > Balance');
  console.log('3. Look for these parameters:');
  console.log('   - YBT Độ lệch tổng hợp (Composite Deviation)');
  console.log('   - YBT Tỷ lệ hiệu suất (Performance Ratio)');
  console.log('   - YBT Tầm với tổng hợp (Composite Reach)');
  console.log('4. If missing, check if raw YBT data exists');
  console.log('5. Calculated parameters should auto-generate from raw data');

  return {
    expectedParams: expectedYBTParams,
    message: 'Check completed - see console for details'
  };
};

// Make it available globally for console use
if (typeof window !== 'undefined') {
  window.checkYBTParameters = checkYBTParameters;
}

// Instructions
console.log(`
🔍 YBT PARAMETER CHECKER
=======================

To check YBT parameters in Vietnamese flowsheet:

1. Open browser console (F12)
2. Run: checkYBTParameters()
3. Follow the manual verification steps
4. Check if calculated parameters are being generated

Expected Vietnamese parameter names:
- YBT Độ lệch tổng hợp (Composite Deviation %)
- YBT Tỷ lệ hiệu suất (Performance Ratio %)
- YBT Tầm với tổng hợp - Phải/Trái (Composite Reach cm)
`);
